/** Matches backend {@code CompanyService#normalizeSupplierTicker} (max 32). */
export const SUPPLIER_TICKER_MAX_LENGTH = 32;

export const normalizeSupplierTicker = (raw) => {
  const normalized = String(raw ?? '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9_]/g, '');
  if (!normalized) return '';
  return normalized.length > SUPPLIER_TICKER_MAX_LENGTH
    ? normalized.slice(0, SUPPLIER_TICKER_MAX_LENGTH)
    : normalized;
};

/** NatureCrunch matrix rows use {@code id} for supplier primary key. */
export const resolveSupplierTickerFromRow = (row) => {
  if (!row || typeof row !== 'object') return '';
  return (
    String(row.ticker ?? '').trim() ||
    String(row.id ?? '').trim() ||
    String(row.supplier_id ?? '').trim() ||
    String(row.supplierId ?? '').trim()
  );
};
